module.exports = __webpack_public_path__ + "images/pro/icon-pro-huge-b3bd0be541f902be1ab8809f0e659d5c.png";